module.exports = __webpack_public_path__ + "media/images/products/products/dummy-6c427e4aa15b2043505516ab209ebadb.jpg";